"use client";
import Translations from "@translate/components/PlaidConnectFlow/shared/PlaidInstitutionCard";

import React, { useState } from "react";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

export interface PlaidInstitutionCardProps {
  name: string;
  logoUrl?: string;
  onClick?: () => void;
  disabled?: boolean;
  /** Clicked-card linking state: spinner replaces the logo so the link-token + Plaid Link open gap is never a silent dead window. */
  loading?: boolean;
  className?: string;
}

export const PlaidInstitutionCard: React.FC<PlaidInstitutionCardProps> = ({
  name,
  logoUrl,
  onClick,
  disabled = false,
  loading = false,
  className = "",
}) => {
  const [imgError, setImgError] = useState(false);

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      data-openreplay-label="plaidconnectflow_institution_tap"
      className={`group w-full bg-background_solid_primary rounded-xl p-3 flex items-center gap-3 text-left border border-border_solid/30 hover:border-border_brand_solid/60 active:scale-[0.99] transition-all cursor-pointer shadow-sm disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      aria-label={name}
    >
      <div className="size-9 rounded-full bg-background_solid_tertiary overflow-hidden shrink-0 flex items-center justify-center border border-border_solid/40">
        {loading ? (
          <span
            className="inline-block size-4 animate-spin rounded-full border-2 border-border_brand_solid border-t-transparent"
            role="status"
            aria-label={I18n.t("Loading")}
            data-testid="institution-card-spinner"
          />
        ) : logoUrl && !imgError ? (
          <img
            src={logoUrl}
            alt={name}
            className="w-full h-full object-cover pointer-events-none"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-content_secondary bg-background_solid_tertiary font-semibold text-sm">
            {name.charAt(0).toUpperCase()}
          </div>
        )}
      </div>
      <span className="text-sm font-medium text-content_primary line-clamp-1 group-hover:text-content_brand_primary transition-colors flex-1">
        {name}
      </span>
    </button>
  );
};
